"use strict";
(function(global) {
    class DdosAlertPreviewController {
        constructor(config) {
            this.settings = {
                charts: {
                    barChart: {
                        dataName: "column_data",
                        id: "bar-chart"
                    }
                },
                colors: {
                    low: "250, 220, 0",
                    medium: "255, 132, 51",
                    high: "213, 71, 51"
                }
            };
            this.init(config);
        }

        init(config) {
            console.log('test-cert');
            this.loadDataChart(config);
        }

        loadDataChart(config) {

            const me = this;
            const cardActions = $('.loading').parents('.card').find('.card-header').find('.actions');
            $(document).bind('ajaxStart', function() {
                $('.loading').show('fast');
                $('.chart-title').hide();
                cardActions.css('opacity', 0);
            })
                .bind('ajaxStop', function() {
                    $('.loading').animate({
                        opacity: 0
                    }, function() {
                        $(this).hide();
                    });
                })

            ApiConnect.get(config.chart_data_url)
                .then(function(data) {
                    me.drawCharts(data);
                })
                .catch(function(errorThrown) {
                    console.log('Błąd wczytywania danych: ', errorThrown);
                }).finally(() => {
                    $('.loading').animate({
                        opacity: 0
                    }, function() {
                        $(this).hide();
                    });
                });
        }

        drawCharts(data) {
            this.barChart = new NS.Charts.LineChartScroll({
                "container-id": this.settings["charts"]["barChart"]["id"],
                "data": data["data"][this.settings["charts"]["barChart"]["dataName"]],
                "multidata": false,
                "scaleLabel": " Mbps"
            });
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.DdosAlertPreviewController = DdosAlertPreviewController || {};

})(window);
